import {
    GET_FISCALYEAR_REQUEST, GET_FISCALYEAR_ERROR, GET_FISCALYEAR_SUCCESS, ADD_FISCALYEAR_REQUEST, ADD_FISCALYEAR_ERROR, ADD_FISCALYEAR_SUCCESS,
    UPDATE_FISCALYEAR_REQUEST, UPDATE_FISCALYEAR_ERROR, UPDATE_FISCALYEAR_SUCCESS, DELETE_FISCALYEAR_REQUEST, DELETE_FISCALYEAR_ERROR, DELETE_FISCALYEAR_SUCCESS
} from "./types"
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getFiscalYear = (token) => (dispatch) => {
    dispatch({ type: GET_FISCALYEAR_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/fiscalYear`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    }).then((response) => {
        return dispatch({ type: GET_FISCALYEAR_SUCCESS, payload: response.data })
    }).catch((error) => {
        return dispatch({ type: GET_FISCALYEAR_ERROR, payload: error.response })
    })
}

export const createFiscalYear = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_FISCALYEAR_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/fiscalYear`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { fiscal_year_name: data.yearName, year_start_date: data.startDate, year_end_date: data.endDate, is_lock: data.lock, is_closed: data.closed, menu_id },
    })
        .then((response) => {
            return dispatch({ type: ADD_FISCALYEAR_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_FISCALYEAR_ERROR,
                payload: error.response,
            });
        });
};

export const updateFiscalYear = (token, data, id) => (dispatch) => {
    
    return axios({
        method: "PUT",
        url: `${BASEURL}update/fiscalYear/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: data,
    })
        .then((response) => {
            return dispatch({ type: UPDATE_FISCALYEAR_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_FISCALYEAR_ERROR,
                payload: error.response,
            });
        });
};

export const deleteFiscalYear = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_FISCALYEAR_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/fiscalYear/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_FISCALYEAR_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_FISCALYEAR_ERROR,
                payload: error.response,
            });
        });
};
